module.exports = "{{text}}";


//////////////////
// WEBPACK FOOTER
// ../src/list/templates/emptyGrid.hbs
// module id = 209
// module chunks = 0